import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import WgptTasksAPI from '../../api/wgpt/tasks';
import types from '../mutation-types';
import { throwErrorMessage } from '../utils/api';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isDeleting: false,
    isUpdating: false,
  },
};

export const getters = {
  getTasks($state) {
    return $state.records;
  },
  getTask: $state => taskId => {
    const task = $state.records.find(record => record.id === Number(taskId));
    return task || {};
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_WGPT_TASKS_UI_FLAG, { isFetching: true });
    try {
      const response = await WgptTasksAPI.get();
      commit(types.SET_WGPT_TASKS, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_TASKS_UI_FLAG, { isFetching: false });
    }
    return null;
  },
  create: async ({ commit }, taskObj) => {
    commit(types.SET_WGPT_TASKS_UI_FLAG, { isCreating: true });
    try {
      const response = await WgptTasksAPI.create(taskObj);
      commit(types.ADD_WGPT_TASK, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_TASKS_UI_FLAG, { isCreating: false });
    }
    return null;
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_WGPT_TASKS_UI_FLAG, { isUpdating: true });
    try {
      const response = await WgptTasksAPI.update(id, updateObj);
      commit(types.EDIT_WGPT_TASK, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_TASKS_UI_FLAG, { isUpdating: false });
    }
    return null;
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_WGPT_TASKS_UI_FLAG, { isDeleting: true });
    try {
      await WgptTasksAPI.delete(id);
      commit(types.DELETE_WGPT_TASK, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_TASKS_UI_FLAG, { isDeleting: false });
    }
    return null;
  },
  show: async ({ commit }, id) => {
    commit(types.SET_WGPT_TASKS_UI_FLAG, { isFetchingItem: true });
    try {
      const { data } = await WgptTasksAPI.show(id);
      commit(types.ADD_WGPT_TASK, data);
      return data;
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_TASKS_UI_FLAG, { isFetchingItem: false });
    }
    return null;
  },
  addFile: async ({ commit }, { id: taskId, file }) => {
    commit(types.SET_WGPT_TASKS_UI_FLAG, { isUpdating: true });
    try {
      const id = Number(taskId);
      const formData = new FormData();
      formData.append('file', file);
      const { data } = await WgptTasksAPI.addFile(id, formData);
      const { files } = data;
      commit(types.EDIT_WGPT_TASK, { id, files });
      return files[files.length - 1];
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_TASKS_UI_FLAG, { isUpdating: false });
    }
  },
};

export const mutations = {
  [types.SET_WGPT_TASKS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.SET_WGPT_TASKS]: MutationHelpers.set,
  [types.ADD_WGPT_TASK]: MutationHelpers.setSingleRecord,
  [types.EDIT_WGPT_TASK]: MutationHelpers.update,
  [types.DELETE_WGPT_TASK]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
